module.exports = __webpack_public_path__ + "img/car_icon.7e605d25.svg";